/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import * as React from "react";
import { useRn620sData } from "./hooks";
import {
  prepareRn620DataGrid,
} from "../helpers";
import "../Config.css";
import CustomDataGrid from "../../../components/Shared/Table/CustomDataGrid";
import { IRn620 } from "../../../store/api/deviceConfig/types";



const Rn620s: React.FC = () => {
  const { data, isLoading, Rn620sColumns } = useRn620sData();

  const getDataFromApi = data?.data || [];
  const rowsData = prepareRn620DataGrid(getDataFromApi) || [];
  const noOfRows = data?.totalItems || 0;

  return (
    <>
      <div
        style={{
          minHeight: "300px",
          border: "1px solid var(--color-border)",
          borderRadius: "var(--radius)",
          padding: "18px",
          boxShadow: "var(--shadow-card)",
          backgroundColor: "var(--card)",
        }}
      >
        {isLoading && <p>Loading...</p>}
        {!isLoading && (
          <CustomDataGrid
            tableId="rn620"
            rows={rowsData}
            columns={Rn620sColumns}
            checkboxSelection={false}
            rowCount={noOfRows}
            loading={isLoading}
            disableColumnMenu={true}
            disableRowSelectionOnClick={true}
            getRowId={(row: IRn620) => row.index}
            sx={{
              "& .MuiDataGrid-virtualScroller": { overflowY: "hidden" },
              "& .MuiDataGrid-scrollbar--vertical": { display: "none" },
            }}
            fillContainer={false}
          />
        )}
      </div>
    </>
  );
};
export default Rn620s;
